// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateChileanDocument(document: string): ?UserInputValidationError {
  if (!document) {
    return { id: 'empty'};
  } else if (!/^[0-9]{7,8}[Kk0-9]$/.test(document)) {
    return { id: 'invalid-rut-pattern' };
  }
}
